"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.USER_NAME = exports.PASSWORD = exports.CREATED_BY = exports.CREATED_AT = exports.CREATE_CONTACT = exports.CAMPAIGN_NAME = exports.SMTP_TOKEN = void 0;
var SMTP_TOKEN = 'SmtpToken';
exports.SMTP_TOKEN = SMTP_TOKEN;
var CAMPAIGN_NAME = 'campaignName';
exports.CAMPAIGN_NAME = CAMPAIGN_NAME;
var CREATE_CONTACT = 'createContact';
exports.CREATE_CONTACT = CREATE_CONTACT;
var CREATED_AT = 'createdAt';
exports.CREATED_AT = CREATED_AT;
var CREATED_BY = 'createdBy';
exports.CREATED_BY = CREATED_BY;
var PASSWORD = 'password';
exports.PASSWORD = PASSWORD;
var USER_NAME = 'userName';
exports.USER_NAME = USER_NAME;